const appConfig = {
    apiPrefix: 'https://dev.backend.nrsportal.co.za/api/v1',
    // apiPrefix: 'http://localhost:8080/api/v1',
    authenticatedEntryPath: '/home',
    otpPath: '/otp',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
    directInterpreter: true,
    network: "TELKMOBL",
    jitsiUrlStaging: 'https://meet.dev.nrsportal.co.za',
    jitsiDomain: 'meet.dev.nrsportal.co.za',
    jitsiWebUrl: 'https://meet.dev.nrsportal.co.za',
    kutoaApiBaseUrl: 'https://dev.nrsportal.co.za',
    logoPath: 'img/logo/kutoa/',
    themeColour: 'Indigo',
    primaryColour: '#0083c2',
    company: '',
    // Client branding properties
    companyName: 'Kutoa Solutions',
    supportEmail: 'support@kutoasolutions.co.za',
    welcomeMessage: 'Welcome, lets get started with Kutoa Solutions EveryVoice Service',
    invalidNumberMessage: 'Not a valid phone number',
    mobileSupportText: 'For mobile concerns—including billing, network connectivity, or call quality—please reach out to support@kutoasolutions.co.za.',
    introText: 'Introducing the National Relay System (NRS), a groundbreaking telecommunications service designed to break down communication barriers and empower individual customers with a valid mobile SIM card, who have either hearing- and/or speech impairement or are a deaf person to be able to contact hearing people of organisations or hearing family and friends, in real-time and on their own by using the NRS platform.'
}

export default appConfig
